module.exports = __webpack_public_path__ + "img/interventional-cardiology.427bb43b.png";